import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Popups from '../containers/Popups';
import classNames from 'classnames';
import {fetchMenuCategoriesIfNeeded} from '../actions/categories';
import {fetchAllReviewsIfNeeded} from '../actions/reviews';
import {execBI} from '../services/bi-events-manager';
import {fetchPendingInMarketIfNeeded} from '../actions/apps-by-type';
import {addExperimentsFromQuery} from '../actions/mode';
import initLNScroll from '../services/ln-scroll';
import {LayoutMetadata} from '../components/Metadata';
import {isExperiment} from '../config';
import _ from 'lodash';

let scrollTopBack = 0;

class Layout extends React.Component {

  static fetchData(dispatch) {
    return Promise.all([
      dispatch(fetchMenuCategoriesIfNeeded())
    ]);
  }

  constructor(props) {
    super(props);
    this.state = {stickyHeader: false};
  }

  componentDidMount() {
    this.props.dispatch(fetchAllReviewsIfNeeded());
    this.props.dispatch(fetchPendingInMarketIfNeeded());
    this.props.dispatch(addExperimentsFromQuery([top.location.search, location.search]));

    const bouncedScrollForContainer = _.debounce((scrolled) => {
      if (this.props.children.type.onScroll) {
        this.props.children.type.onScroll(scrolled, this.props.dispatch, this.props.params, this.props.location);
      }
    }, 300, {maxWait: 1600});

    const handleScroll = (scrolled, scrollTop) => {
      bouncedScrollForContainer(scrolled);

      // Sticky header
      if (scrollTop >= 78 && !this.state.stickyHeader) {
        this.setState({stickyHeader: true});
      } else if (scrollTop < 78 && this.state.stickyHeader) {
        this.setState({stickyHeader: false});
      }
    };

    const prepareScrollOnWindow = () => {
      const top = window.pageYOffset;
      const scrolled = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      handleScroll((top + 1) / (scrolled + 1), top);
    };

    // Editor market have styled scroll on ln-scroll element. Modal is an App/Permissions popup iFrame in Editor.
    if (!this.props.isModal && this.props.market === 'editor') {
      initLNScroll(window.document.getElementById('ln-scroll-inner'), handleScroll);
    }

    // Standalone and Dashboard markets use default scroll
    if (this.props.market !== 'editor') {
      window.addEventListener('scroll', prepareScrollOnWindow);
      prepareScrollOnWindow();
    }

    execBI('APP_MARKET_OPENED');
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.params.appSlug && nextProps.params.appSlug) {
      scrollTopBack = this.props.market === 'editor' ? window.document.getElementById('ln-scroll-inner').scrollTop : window.pageYOffset;
    }

    if (!(this.props.isAppPage && nextProps.isAppPage)) {
      window.document.getElementById('ln-scroll-inner').scrollTop = 0;
      window.scrollTo(0, 0);
    }

    this.setState({stickyHeader: false});
  }

  componentDidUpdate(prevProps) {
    if (!this.props.params.appSlug && prevProps.params.appSlug) {
      if (this.props.market === 'editor') {
        window.document.getElementById('ln-scroll-inner').scrollTop = scrollTopBack;
      } else {
        window.scrollTo(0, scrollTopBack);
      }
    }
  }


  render() {
    const {children, header, isModal, market, isCategoryPage, isAppPage} = this.props;
    const classes = {
      'modal-page': isModal,
      [`app-market-${market}`]: true,
      'app-market-no-header-category-page': isCategoryPage,
      'app-page-layout': isAppPage && !isModal,
      'app-market-no-header': isExperiment('appMarketNoHeader', this.props.experiments) || this.props.market === 'standalone',
      'sticky-header': this.state.stickyHeader
    };

    return (
      <div id="app-market">
        <div className={classNames('page', classes)}>
          <LayoutMetadata location={this.props.location} lang={this.props.lang}/>
          {header}
          <div className="header-space"></div>
          <div className="ln-scroll">
            <div className="ln-scroll-inner" id="ln-scroll-inner">
              <div className="ln-scroll-content">
                {children}
              </div>
            </div>
          </div>
          <Popups/>
        </div>
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  isModal: PropTypes.bool,
  market: PropTypes.string.isRequired,
  dispatch: PropTypes.func,
  params: PropTypes.object,
  location: PropTypes.object,
  isCategoryPage: PropTypes.bool,
  isAppPage: PropTypes.bool,
  lang: PropTypes.string,
  experiments: PropTypes.object
};

function mapStateToProps(state, props) {
  return {
    isModal: props.children.props.route.isModal,
    market: state.mode.market,
    isCategoryPage: !!props.params.category,
    isAppPage: !!props.params.appSlug,
    lang: state.mode.lang,
    experiments: state.mode.experiments
  };
}

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./containers/Layout.js